import { render, staticRenderFns } from "./CargaMasivaMatriz.vue?vue&type=template&id=5cf8fb2a&"
import script from "./CargaMasivaMatriz.vue?vue&type=script&lang=js&"
export * from "./CargaMasivaMatriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports